import request from '../request'
export default {
    
    /**
     * 查询字典的问题类型
     */
    selectDictType: (para, suss, err) => request.request('client/discoverProblem/selectDictType', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),

    /**
     * 查询物料代码字典
     */
    selectBillDict: (para, suss, err) => request.request('client/discoverProblem/getERPBillList', para, 'get', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 选择合作伙伴公司
     */
    selectAllPartner: (para, suss, err) => request.request('client/discoverProblem/selectAllPartner', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 创建问题接口
     */
    createQuestion: (para, suss, err, complete_fun) => request.upload('client/discoverProblem/createQuestion', para, () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }, () => { if (complete_fun !== undefined) { return e => { complete_fun(e) } } else { return null } }),
    
    /**
     * 编辑问题
     */
    QuestionExamine: (para, suss, err, complete_fun) => request.upload('client/discoverProblem/QuestionExamine', para, () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }, () => { if (complete_fun !== undefined) { return e => { complete_fun(e) } } else { return null } }),
    
    /**
     * 根据合作公司ID查找所有的用户
     */
    selectAllUserByCompanyId: (para, suss, err) => request.request('client/discoverProblem/selectAllUserByCompanyId', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 发现问题列表
     */
    getProblemsList: (para, suss, err) => request.request('client/discoverProblem/getProblemsList', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 取得左侧部门树
     */
    getTree: (para, suss, err) => request.request('client/txl/department/getTree', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),

    /**
     * 获取部门成员
     */
    getDepartmentMembers: (para, suss, err) => request.request('client/sq/getDepartmentMembers', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 获取下级部门
     */
    getChildDepartment: (para, suss, err) => request.request('client/txl/department/getChildDepartment', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 取得合作伙伴类型
     */
    getPartnerTypeList: (para, suss, err) => request.request('client/partner/getPartnerTypeList', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 取得合作伙伴列表
     */
    getPartnerList: (para, suss, err) => request.request('client/partner/getPartnerList', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
   
    /**
     * 取得合作伙伴详情
     */
    getSurfaceCompanyMessage: (para, suss, err) => request.request('ent/visibleSetting/getSurfaceCompanyMessage', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 展开查看成员
     */
    getPartnerDetail: (para, suss, err) => request.request('client/partner/getPartnerDetail', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 展开查看成员
     */
    getCondition: (para, suss, err) => request.request('client/partner/getCondition', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 取得所有数据
     */
    searchMembers: (para, suss, err) => request.request('/txl/department/searchMembers', para, 'get', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),

    /**
     * 评价报告
     */
    CommentReport: (para, suss, err) => request.request('client/discoverProblem/CommentReport', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
    
    /**
     * 导出发现问题
     */
    discoverProblemsExport: (para, suss, err) => request.request('client/discoverProblem/discoverProblemsExport', para, 'post', () => { if (suss !== undefined) { return e => { suss(e) } } else { return null } }, () => { if (err !== undefined) { return e => { err(e) } } else { return null } }),
}


// WEBPACK FOOTER //
// ./src/api/findTask.js